import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { images } from "../assets";
import APIService from "../services/APIService";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { saveAuthen } from "../app/features/authen";
import { Form, Input } from "antd";
import { saveCookies } from "../utils";

export default function SingInPage() {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const { value: showPassword, handleToggleValue: handleTogglePassword } =
  //   useToggleValue();

  async function login(values) {
    const RESULT = await APIService.login(values.username, values.password);
    if (RESULT) {
      const infoUser = {
        name: RESULT.drug_store.name,
        token: RESULT.token,
      };
      dispatch(saveAuthen(RESULT));
      debugger;
      if (location.state?.from == "signup") {
        navigate("/");
      } else {
        navigate(-1);
      }
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSignIn = (values) => {
    console.log(values);
    login(values);
  };
  return (
    <div className="flex flex-row w-screen h-full">
      <div className="singin flex flex-2 justify-center items-center flex-col gap-y-[29px] md:flex hidden">
        <img
          src={images.newsignup}
          className="w-full h-full bg-no-repeat bg-contain"
          alt=""
        />
        {/* <button className="w-[155px] h-[38px] p-2 rounded-[30px] bg-[#ffffff]">
          <Link
            className="text-base font-extrabold text-[#119AE2] not-italic capitalize "
            to="/contact"
          >
            Liên Hệ Ngay
          </Link>
        </button> */}
      </div>
      <div className="flex flex-col justify-center p-3 mb-10 md:items-center flex-3">
        <div className="w-[164px] h-[174px] mx-auto">
          <img src={images.logoPNG} className="w-full h-full" alt="" />
        </div>
        <div className="flex flex-col gap-y-[12px] form_signin">
          <h2 className="md:text-xl text-base  font-black text-[#373737] m-auto">
            ĐĂNG NHẬP
          </h2>
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={handleSignIn}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="flex md:w-[495px] w-full bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-8 ">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <MailOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="pl-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Email
                  </label>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item className="w-full m-0 " name="username">
                    <Input
                      bordered={false}
                      className="text-sm font-semibold font-weight placeholder:italic"
                      placeholder="Nhập tên đăng nhập"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="flex md:w-[495px] w-full bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <LockOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="px-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Mật khẩu
                  </label>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item className="w-full m-0" name="password">
                    <Input.Password
                      bordered={false}
                      placeholder="Nhập mật khẩu"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="text-right">
              <span className="inline-block md:text-sm text-xs font-normal cursor-pointer text-[#222222]">
                Quên mật khẩu?
              </span>
            </div>
            <div className="flex justify-center text-white font-bold item-center my-[12px] mt-10">
              <button
                type="submit"
                className="md:w-[252px] w-[181px] md:h-[50px] p-2 rounded-[30px]  bg-[#119AE2]"
              >
                ĐĂNG NHẬP
              </button>
            </div>
          </Form>
        </div>
        <p className="mb-6 text-xs font-normal text-center lg:text-sm text-text3 lg:mb-8">
          Bạn chưa có tài khoản{" "}
          <Link
            to="/signup"
            className="font-bold underline text-sm text-[#119AE2]"
          >
            ĐĂNG KÝ
          </Link>
        </p>
        <div className="w-[93px] h-[1px] bg-[#119AE2] mb-3 mx-auto"></div>
        <Link
          to="/"
          className="flex justify-center text-white font-bold item-center my-[12px]"
        >
          <button
            type="submit"
            className="md:w-[252px] w-[181px] md:h-[50px] p-2 rounded-[30px]  bg-[#7F4CEB]"
          >
            TIẾP TỤC MUA HÀNG
          </button>
        </Link>
      </div>
    </div>
  );
}
